import { handleTrack } from '../../../utils/tracker';
import { Button, ButtonVariants } from '../../Atoms/Button';

export const ScrollTopButton = (): JSX.Element => {
  const handleEvent = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    handleTrack({
      label: 'scroll_to_top',
    });
  };
  return (
    <div
      className="fixed bottom-16 right-9 sm:hidden cursor-pointer"
      onClick={handleEvent}
    >
      <Button
        variant={ButtonVariants.bluefilled}
        rounded=""
        className="rounded-full w-14 h-14 focus:outline-0"
      >
        <img
          className="w-4 h-4"
          src="https://assets.clear.in/cleartax/images/1695888732_group181441831.png"
        />
      </Button>
      <p className="text-s-12 mt-3 font-bold text-grey-970">Scroll Top</p>
    </div>
  );
};
